"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Table = _interopRequireDefault(require("./Table"));

var _Sorter = require("../Sorter/Sorter");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * LocalTable component. The recommended use case for this component is if
 * all data is available locally so that this component can accurately keep
 * track of the data after pagination, sorting and selection in its state.
 * If more data needs to be fetched from a server, then it is recommended to
 * use the Table component directly
 */
var LocalTable =
/*#__PURE__*/
function (_React$Component) {
  _inherits(LocalTable, _React$Component);

  function LocalTable(props) {
    var _this;

    _classCallCheck(this, LocalTable);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LocalTable).call(this, props));

    _this.handlePaginationChange = function (pagination, nextPage, pageSize) {
      var onChangePagination = _this.props.onChangePagination;

      _this.setState({
        pagination: pagination
      });

      if (onChangePagination) {
        onChangePagination(pagination, nextPage, pageSize);
      }
    };

    _this.handleRowSelectionChange = function (rowSelection, selected, unselected) {
      var onChangeRowSelection = _this.props.onChangeRowSelection;

      _this.setState({
        rowSelection: rowSelection
      });

      if (onChangeRowSelection) {
        onChangeRowSelection(rowSelection, selected, unselected);
      }
    };

    _this.handleSortChange = function (sort, order, column) {
      var onChangeSort = _this.props.onChangeSort;

      _this.setState({
        sort: sort
      });

      if (onChangeSort) {
        onChangeSort(sort, order, column);
      }
    };

    _this.state = {
      pagination: props.pagination,
      rowSelection: props.rowSelection,
      sort: props.sort
    };
    return _this;
  }
  /**
   * componentWillReceiveProps enables to update the state
   * depending on the existing and upcoming props
   * @param {string} nextProps handles the next available props.
   */


  _createClass(LocalTable, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      // If component wants to update the state, they should pass in a new object
      // Don't want to do a deep compare for performance
      if (nextProps.pagination !== this.state.pagination) {
        this.setState({
          pagination: nextProps.pagination
        });
      }

      if (nextProps.rowSelection !== this.state.rowSelection) {
        this.setState({
          rowSelection: nextProps.rowSelection
        });
      }

      if (nextProps.sort !== this.state.sort) {
        this.setState({
          sort: nextProps.sort
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(_Table.default, _extends({}, this.props, {
        oldTable: false,
        dataSource: this.getLocalData(),
        pagination: this.state.pagination,
        rowSelection: this.state.rowSelection,
        sort: this.state.sort,
        onChangePagination: this.handlePaginationChange,
        onChangeRowSelection: this.handleRowSelectionChange,
        onChangeSort: this.handleSortChange
      }));
    }
    /**
     * Get data source with pagination and sorting applied
     * @returns {Object} - Data source with pagination and sorting applied
     */

  }, {
    key: "getLocalData",
    value: function getLocalData() {
      var _this$state = this.state,
          pagination = _this$state.pagination,
          sort = _this$state.sort;
      var _this$props = this.props,
          dataSource = _this$props.dataSource,
          sorters = _this$props.sorters;
      var data = dataSource.slice(0);

      if (sort && sort.order && sort.order !== _Sorter.SORT_ORDER_CONST.NONE && sorters && typeof sorters[sort.column] === 'function') {
        data.sort(function (a, b) {
          var sortOrder = sort.order;
          var result = sorters[sort.column](a, b);

          if (result !== 0) {
            return sortOrder === _Sorter.SORT_ORDER_CONST.DESCEND ? -result : result;
          }

          return 0;
        });
      }

      if (pagination) {
        var startIndex = (pagination.currentPage - 1) * pagination.pageSize;
        var endIndex = startIndex + pagination.pageSize;
        data = data.slice(startIndex, endIndex);
      }

      return data;
    }
    /**
     * Handle pagination change
     * @param {Object} pagination - Suggested pagination state
     * @param {number} nextPage - Suggested next page
     * @param {number} pageSize - Suggested page size
     */

  }]);

  return LocalTable;
}(_react.default.Component);

exports.default = LocalTable;
LocalTable.defaultProps = {};
LocalTable.propTypes = {
  /**
   * See Table columns propType for more info
   */
  columns: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,

  /**
   * See Table dataSource propType for more info
   */
  dataSource: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,

  /**
   * See Table pagination propType for more info
   */
  pagination: _propTypes.default.object,

  /**
   * See Table rowSeletion propType for more info
   */
  rowSelection: _propTypes.default.object,

  /**
   * See Table sort propType for more info
   */
  sort: _propTypes.default.object,

  /**
   * Map of column sorters. Each property should be a column key
   */
  sorters: _propTypes.default.object
};